Sets general block wrappers with reasonable default values. You can use it
without any vertical or horizontal spacings: - StandardWrapper noPadding
width="full"

<template>
  <ResponsiveWrapper
    v-if="!editorOnly || isVisualEditor"
    :component="blok.component"
    :devices="unresponsive ? ['mobile', 'tablet', 'desktop'] : blok.devices"
  >
    <BackgroundWrapper :blok="blok" :is-active="!noBackground">
      <SectionWrapper
        :blok="blok"
        class="relative"
        :class="[allowOverflow ? '' : 'overflow-hidden']"
        :is-section="!noSection"
        :padding="noPadding ? 'none' : null"
      >
        <WidthWrapper :width="width" class="relative">
          <div v-if="editorOnly && isVisualEditor">
            This block is only displayed in the Visual Editor
          </div>
          <slot />
        </WidthWrapper>
      </SectionWrapper>
    </BackgroundWrapper>
  </ResponsiveWrapper>
</template>

<script setup>
import ResponsiveWrapper from './ResponsiveWrapper.vue'
import BackgroundWrapper from './BackgroundWrapper.vue'
import SectionWrapper from './SectionWrapper.vue'
import WidthWrapper from './WidthWrapper.vue'
import { computed } from 'vue'

defineProps({
  blok: {
    type: Object,
    required: true,
  },
  // If true, block is always visible for any screen widths
  unresponsive: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: 'block',
  },
  // If true, remove vertical padding
  noPadding: {
    type: Boolean,
    default: false,
  },
  allowOverflow: {
    type: Boolean,
    default: false,
  },
  // If true, don't wrap the block in a <section> element
  noSection: {
    type: Boolean,
    default: false,
  },
  // If true, don't define any background color for the block (block background is transparent)
  noBackground: {
    type: Boolean,
    default: false,
  },
  editorOnly: {
    type: Boolean,
    default: false,
  },
})

const isVisualEditor = computed(() => {
  return import.meta.env.VITE_IS_EDITOR || false
})
</script>
